import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { StorageService } from 'app/core/auth/storage.service';

@Component({
    selector: 'app-select-outlet',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './select-outlet.component.html',
    styleUrl: './select-outlet.component.scss',
})
export class SelectOutletComponent implements OnInit {
    outlets: any[] = [];

    constructor(
        private router: Router,
        private storage: StorageService
    ) {}

    ngOnInit(): void {
        // Get outlets from localStorage
        this.outlets = this.storage.getOutlets();

        // If no outlets or already has selected outlet, go to dashboard
        if (this.outlets.length === 0) {
            this.redirectAfterOutlet();
            return;
        }

        const selectedOutlet = this.storage.getOutlet();
        if (selectedOutlet) {
            this.redirectAfterOutlet();
        }
    }

    selectOutlet(outlet: any): void {
        this.storage.setOutlet(outlet);
        this.redirectAfterOutlet();
    }

    private redirectAfterOutlet(): void {
        if (localStorage.getItem('must_change_pwd') === 'true') {
            this.router.navigate(['/settings/change-password'], { replaceUrl: true });
        } else {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
        }
    }
}
